import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { ContentProvider } from "@/lib/contentStore";
import { ADMIN_BASE_PATH, ADMIN_LOGIN_PATH, ADMIN_WILDCARD_PATH } from "@/lib/panelPaths";
import SiteLayout from "@/components/SiteLayout";
import {
  AboutPage,
  CatalogPage,
  CategoryPage,
  ContactsPage,
  HomePage,
  NotFoundPage,
  ProductPage,
} from "@/pages/SitePages";

import AdminDashboard, { AdminGate, AdminLogin } from "@/pages/Admin";

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/catalog/:categorySlug" element={<CategoryPage />} />
            <Route path="/product/:productSlug" element={<ProductPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contacts" element={<ContactsPage />} />

            <Route path={ADMIN_LOGIN_PATH} element={<AdminLogin />} />
            <Route
              path={ADMIN_BASE_PATH}
              element={
                <AdminGate>
                  <AdminDashboard />
                </AdminGate>
              }
            />
            <Route path={ADMIN_WILDCARD_PATH} element={<Navigate to={ADMIN_BASE_PATH} replace />} />

            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
